import getFormattingLocale from './getFormattingLocale';

function formatCurrency(price?: number | string, currency = 'USD'): string {
  if (price === null || price === undefined || price === '') return '';

  const currentLocale = getFormattingLocale();
  const numValue = Number(price);

  if (Number.isNaN(numValue)) return '';

  const formatter = new Intl.NumberFormat(currentLocale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
  });

  const formatted = formatter.format(numValue);

  if (currency === 'CAD') {
    return `${formatted} CA`;
  }

  const isEnglish = currentLocale.startsWith('en');
  if (!isEnglish && currency === 'USD') {
    return `${formatted} US`;
  }

  return formatted;
}

export default formatCurrency;
